angular.module('invoice', ['core', 'clients', 'agreements'])
    .constant('InvoiceConst', {
        eventUpdate: 'invoice.updated'
    })
    .factory('Invoice', function ($resource) {
        return $resource('/crm/api/invoice/:id', {id: '@id'}, {
            allGranted: {method: 'GET', isArray: false, url: '/crm/api/invoice/all-granted'},
            table: {method: 'GET', isArray: false, url: '/crm/api/invoice/table'},
            tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/invoice/table-statistics'},
            update: {method: 'PUT'},
            pass: {method: 'PUT', url: '/crm/api/invoice/:id/pass'},
            passMany: {method: 'POST', url: '/crm/api/invoice-pass-batch'},
            history: {method: 'GET', isArray: true, url: '/crm/api/invoice/:id/history'},
            ocr: {method: 'POST', url: '/crm/api/invoice/:id/ocr'},
            duplicate: {method: 'POST', url: '/crm/api/invoice/:id/duplicate'},
            remove: {method: 'DELETE'},
            deleteBatch: {method: 'POST', url: '/crm/api/invoice/batch-delete'},
            types: {method: 'GET', isArray: true, url: '/crm/api/invoice-type'},
            statuses: {method: 'GET', isArray: true, url: '/crm/api/invoice-status'},
            workflowConfiguration: {method: 'GET', url: '/crm/api/invoice-workflow/configuration'},
            transfers: {method: 'GET', isArray: true, url: '/crm/api/invoice/:id/transfers'},
            settlements: {method: 'GET', isArray: true, url: '/crm/api/invoice/:id/settlements'},
            saveSettlement: {method: 'POST', isArray: true, url: '/crm/api/invoice/:id/settlements'},
            updateSettlement: {method: 'PUT', isArray: true, url: '/crm/api/invoice/:id/settlements/:settlementId', params: {settlementId: '@settlementId'}},
            deleteSettlement: {method: 'DELETE', isArray: true, url: '/crm/api/invoice/:id/settlements/:settlementId', params: {settlementId: '@settlementId'}},
            touches: {method: 'GET', isArray: true, url: '/crm/api/invoice/:id/touches'},
            deleteTouch: {method: 'DELETE', url: '/crm/api/invoice/:id/touches/:userId'},
            addTouchOnly: {method: 'POST', url: '/crm/api/invoice/:id/touches'},
            costs: {method: 'GET', isArray: true, url: '/crm/api/invoice/:id/costs'},
            settings: {method: 'GET', url: '/crm/api/invoice-settings'},
            saveSettings: {method: 'POST', url: '/crm/api/invoice-settings'},
            statusSettings: {method: 'GET', url: '/crm/api/invoice-settings/status'},
            substantiveDescription: {method: 'GET', url: '/crm/api/invoice/:id/substantive-description'},
            saveSubstantiveDescription: {method: 'PUT', url: '/crm/api/invoice/:id/substantive-description'},
            additionalInfo: {method: 'GET', url: '/crm/api/invoice/:id/additional-info'},
            saveAdditionalInfo: {method: 'PUT', url: '/crm/api/invoice/:id/additional-info'},
            ksefCosts: {method: 'GET', isArray: true, url: '/crm/api/invoice/:id/ksef-costs'},
            toggleFlag: {method: 'PUT', url: '/crm/api/invoice/:id/flag'},
            resetKsefXmlExport: {method: 'POST', url: '/crm/api/invoice/ksef-export/reset'},
            workerAbsences: {method: 'POST', isArray: true, url: '/crm/api/invoice/workers/absences'},
        })
    })
    .factory('InvoiceWorkflow', function (Invoice) {
        let configurationPromise
        let configuration

        const normalize = result => {
            const agreementOrAssignment = result.agreementOrAssignment
            if (agreementOrAssignment && agreementOrAssignment.bypassBelowGross == null) {
                agreementOrAssignment.bypassBelowGross = agreementOrAssignment.requiredAboveGross || {}
            }
            if (agreementOrAssignment && !Array.isArray(agreementOrAssignment.linkableOrderStatuses)) {
                agreementOrAssignment.linkableOrderStatuses = []
            }
            return result
        }

        const load = () => {
            if (configurationPromise == null) {
                configurationPromise = Invoice.workflowConfiguration().$promise.then(result => {
                    configuration = normalize(result)
                    return configuration
                }).catch(error => {
                    configurationPromise = null
                    throw error
                })
            }
            return configurationPromise
        }

        return {
            load: load,
            get configuration() {
                return configuration
            },
            availableStatuses: (currentStatus) => load().then(config => {
                const transitions = config.transitions[currentStatus] || []
                const allowed = transitions.concat(currentStatus ? [currentStatus] : [])
                return config.statuses.filter(status => allowed.includes(status))
            }),
            isTerminal: status => configuration == null || configuration.terminalStatuses.includes(status)
        }
    })
    .component('invoiceAssignmentWorkflowOption', {
        bindings: {
            enabled: '<',
            userCount: '<',
            onChange: '&'
        },
        template: `
            <div class="separator-between separator-before">
                <div class="form-group form-flex">
                    <label for="invoiceAssignmentWorkflow{{$ctrl.instanceId}}" translate="invoice.assignment.remaining-users"></label>
                    <div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" id="invoiceAssignmentWorkflow{{$ctrl.instanceId}}" ng-model="$ctrl.enabled" ng-disabled="$ctrl.userCount < 2" ng-change="$ctrl.onChange({enabled: $ctrl.enabled})" aria-describedby="invoiceAssignmentWorkflowHelp{{$ctrl.instanceId}}"/>
                            <label class="form-check-label" for="invoiceAssignmentWorkflow{{$ctrl.instanceId}}"><span translate="invoice.assignment.add-rule-users-to-workflow"></span></label>
                        </div>
                        <div class="help-block" id="invoiceAssignmentWorkflowHelp{{$ctrl.instanceId}}" translate="invoice.assignment.add-rule-users-to-workflow.help"></div>
                    </div>
                </div>
            </div>
        `,
        controller: function ($scope) {
            this.instanceId = $scope.$id
            this.$onChanges = () => {
                if (this.userCount < 2 && this.enabled) {
                    this.enabled = false
                    this.onChange({enabled: false})
                }
            }
        }
    })
    .component('invoiceCodeNameLabel', {
        bindings: {
            code: '<',
            name: '<',
            active: '<',
            format: '@?',
            nameClass: '@?'
        },
        template: `
            <span ng-if="$ctrl.format === 'short'" uib-tooltip="{{$ctrl.name}}" style="color: navy">
                <span ng-if="$ctrl.code" class="bold">{{$ctrl.code}}</span>
                <span ng-if="!$ctrl.code && $ctrl.name" ng-class="$ctrl.nameClass">{{$ctrl.name}}</span>
            </span>
            <span ng-if="$ctrl.format === 'full'">
                <span ng-if="$ctrl.code" class="bold" style="color: navy">{{$ctrl.code}}</span>
                <span ng-if="$ctrl.code && $ctrl.name">&nbsp;-&nbsp;</span>
                <span ng-if="$ctrl.name" ng-class="$ctrl.nameClass">{{$ctrl.name}}</span>
            </span>
            <span ng-if="$ctrl.active === false" title="Nieaktywny" class="bold text-danger">&nbsp;N&nbsp;</span>
        `,
        controller: function () {
            this.$onInit = () => {
                if (this.format == null) {
                    this.format = 'short'
                }
            }
        }
    })
    .component('invoiceStatusLabel', {
        bindings: {
            status: '<',
            abbreviated: '<'
        },
        template: `
            <span class="label label-default invoice-status {{$ctrl.status}}"
                  ng-if="$ctrl.status != null"
                  aria-label="{{ 'invoice.status.'.concat($ctrl.status) | translate }}"
                  uib-tooltip="{{ 'invoice.status.'.concat($ctrl.status) | translate }}"
                  tooltip-enable="$ctrl.abbreviated">
                <span ng-if="$ctrl.abbreviated">{{ 'invoice.status.'.concat($ctrl.status) | translate | initials }}</span>
                <span ng-if="!$ctrl.abbreviated">{{ 'invoice.status.'.concat($ctrl.status) | translate }}</span>
            </span>
        `
    })
    .component('invoiceMenuOptions', {
        templateUrl: 'app/invoice/_menu-options.html',
        controller: function (InvoiceService) {
            this.InvoiceService = InvoiceService
        }
    })
    .controller('InvoiceShortAcceptanceGuideController', function ($document, $window) {
        this.scrollTo = sectionId => {
            const section = $document[0].getElementById(sectionId)
            if (section == null) {
                return
            }
            const prefersReducedMotion = $window.matchMedia && $window.matchMedia('(prefers-reduced-motion: reduce)').matches
            section.scrollIntoView({behavior: prefersReducedMotion ? 'auto' : 'smooth', block: 'start'})
            section.focus({preventScroll: true})
        }
    })
    .component('invoiceCurrencySummary', {
        bindings: {
            summaries: '<',
            referenceSummaries: '<',
            property: '@',
            emphasized: '<',
            properties: '<'
        },
        template: `
            <div ng-if="!$ctrl.values.length">
                <div class="invoice-currency-summary__row" ng-class="{'total': $ctrl.emphasized}" ng-repeat="row in $ctrl.rows track by row.currency">
                    <span class="invoice-currency-summary__currency">{{row.currency}}</span>
                    <span class="invoice-currency-summary__amount">{{$ctrl.value(row.summary) | number: 2}}</span>
                </div>
            </div>
            <table class="invoice-currency-summary__table" ng-if="$ctrl.values.length">
                <thead>
                <tr>
                    <th scope="col" aria-label="{{ 'currency' | translate }}"></th>
                    <th scope="col" ng-repeat="value in $ctrl.values track by value.id" translate="pricing.summary.{{value.id}}"></th>
                </tr>
                </thead>
                <tbody>
                <tr ng-class="{'total': $ctrl.emphasized}" ng-repeat="row in $ctrl.rows track by row.currency">
                    <td class="invoice-currency-summary__currency">{{row.currency}}</td>
                    <td ng-class="value.id + '-price'" ng-repeat="value in $ctrl.values track by value.id">{{value.get(row.summary) | number: 2}}</td>
                </tr>
                </tbody>
            </table>
        `,
        controller: function ($parse) {
            const valueProperties = {
                net: 'pricing.totalNet',
                vat: 'pricing.totalVat',
                gross: 'pricing.totalGross'
            }
            this.value = () => undefined
            this.values = []
            this.$onChanges = () => {
                this.value = $parse(this.property || '')
                this.values = (this.properties || []).filter(id => valueProperties[id]).map(id => ({id: id, get: $parse(valueProperties[id])}))
                const summaries = this.summaries || []
                const referenceSummaries = this.referenceSummaries || []
                const summariesByCurrency = summaries.reduce((result, summary) => {
                    result[summary.currency] = summary
                    return result
                }, {})
                this.rows = referenceSummaries.concat(summaries)
                    .filter(summary => summary && summary.currency)
                    .map(summary => summary.currency)
                    .filter((currency, index, values) => values.indexOf(currency) === index)
                    .sort()
                    .map(currency => ({currency: currency, summary: summariesByCurrency[currency]}))
            }
        }
    })
    .service('InvoiceService', function ($http, $rootScope, $state, $cookies, toastr, modals, Invoice, ModuleSettings, FilesSimpleUploadService, InvoiceConst, Principal, InvoiceBgtImportService, InvoiceWorkflow) {
        this.workflow = InvoiceWorkflow

        this.createFromClassification = classification => {
            return $http.post('/crm/api/file-association-invoice/from-file-id', {fileId: classification.file.id, description: classification.description})
                .then(response => {
                    $state.go('invoiceRegistration', {id: response.data.id})
                    return true
                })
        }
        this.uploadFiles = () => {
            let filters = [{
                name: 'Filtr PDF',
                fn: function (item /*{File|FileLikeObject}*/, options) {
                    var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                    return '|pdf|'.indexOf(type) !== -1;
                }
            }]
            return FilesSimpleUploadService.open({type: 'INVOICE', filters: filters}).then(() => $rootScope.$broadcast(InvoiceConst.eventUpdate))
        }
        this.uploadMainFile = item => {
            let filters = [{
                name: 'Filtr PDF',
                fn: function (item /*{File|FileLikeObject}*/, options) {
                    var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                    return '|pdf|'.indexOf(type) !== -1;
                }
            }]
            return FilesSimpleUploadService.openCustom({url: `/crm/api/file-association-invoice/${item.id}/main-file`, settings: {filters: filters}}).then(() => $rootScope.$broadcast(InvoiceConst.eventUpdate))
        }
        this.duplicate = id => {
            return modals.confirm("Czy na pewno chcesz powielić dokument?", () => Invoice.duplicate({id: id}).$promise.then(result => {
                $state.go('invoiceShowFull', {id: result.id})
            }))
        }
        this.show = entity => {
            return modals.open('app/invoice/show-modal.html', 'InvoiceShowController', entity, {size: "lg"}, "$ctrl")
        }
        this.canCreateAssignmentRule = () => {
            return Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_ACCOUNTING', 'ROLE_INVOICE_DOCUMENTS_ALL', 'ROLE_ADMIN'])
        }
        this.openAssignmentRuleModal = item => {
            if (!item) {
                return
            }
            if (!this.canCreateAssignmentRule()) {
                toastr.error("Brak uprawnień")
                return
            }
            if (!item.seller || !item.seller.taxNo || !item.buyer) {
                toastr.warning("Brak danych do utworzenia reguły")
                return
            }
            let modalData = {
                invoiceId: item.id,
                seller: item.seller,
                buyer: item.buyer,
                worker: item.worker,
                scope: 'LOCAL',
                canCreateGlobalRule: Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_ACCOUNTING', 'ROLE_INVOICE_DOCUMENTS_ALL', 'ROLE_ADMIN'])
            }
            return modals.open(
                'app/invoice/assignment-rule-from-invoice-modal.html',
                'InvoiceAssignmentRuleFromInvoiceController',
                modalData,
                {size: "md"},
                "$ctrl"
            )
        }
        this.addTouchOnly = entity => {
            return modals.open('app/invoice/add-touch-only-modal.html', 'InvoiceAddTouchOnlyController', entity.id, {size: "md"}, "$ctrl")
        }
        this.history = entity => {
            return modals.open('app/invoice/history-modal.html', 'InvoiceHistoryController', entity.id, {size: "lg"}, "$ctrl")
        }
        this.percentage = (value, divider) => {
            return this.divide(this.multiply(value, 100), divider)
        }
        this.divide = (value, divider) => {
            return (divider && value !== undefined) ? Math.round(value * 100 / divider) / 100 : undefined
        }
        this.multiply = (value, multiplier) => {
            return Math.round(value * 100 * multiplier) / 100
        }
        this.add = (value, add) => {
            return Math.round(value * 100 + add * 100) / 100
        }
        this.sub = (value, sub) => {
            return Math.round(value * 100 - sub * 100) / 100
        }
        this.round = value => {
            return Math.round(value * 100) / 100
        }
        this.sum = items => {
            let zeros = {totalNet: 0, totalVat: 0, totalGross: 0}
            return items.reduce((sum, price) => {
                return {
                    totalNet: this.add(sum?.totalNet, price?.totalNet),
                    totalVat: this.add(sum?.totalVat, price?.totalVat),
                    totalGross: this.add(sum?.totalGross, price?.totalGross)
                }
            }, zeros)
        }
        this.sumInvoicesByCurrency = items => {
            let totals = {}
            ;(items || []).forEach(item => {
                if (!item) {
                    return
                }
                let currency = item.currency || 'PLN'
                if (!totals[currency]) {
                    totals[currency] = {currency: currency, pricing: this.sum([]), paidAmountLeft: this.sum([])}
                }
                if (item.pricing != null) {
                    totals[currency].pricing = this.sum([totals[currency].pricing, item.pricing])
                }
                if (item.paidAmountLeft != null) {
                    totals[currency].paidAmountLeft = this.sum([totals[currency].paidAmountLeft, item.paidAmountLeft])
                }
            })
            return Object.keys(totals).sort().map(currency => totals[currency])
        }
        this.sumDecimal = items => {
            return items.reduce((sum, item) => this.add(sum, item), 0)
        }
        this.pass = item => {
            return modals.open('app/invoice/pass-modal.html', 'InvoicePassController', item, {size: "sm"}, "$ctrl")
        }
        this.passMany = items => {
            return modals.open('app/invoice/pass-many-modal.html', 'InvoicePassManyController', items, {size: "lg"}, "$ctrl")
        }
        this.settings = item => {
            return modals.open('app/invoice/_settings-modal.html', 'InvoiceSettingsController', item, {size: "lg"}, "$ctrl")
        }
        this.workflowConfiguration = () => {
            return modals.open('app/invoice/workflow-configuration-modal.html', 'InvoiceWorkflowConfigurationController', null, {size: "lg"}, "$ctrl")
        }
        this.additionalInfo = item => {
            return modals.open('app/invoice/additional-info-modal.html', 'InvoiceAdditionalInfoController', item, {size: "md"}, "$ctrl")
        }
        this.isAdditionalInfoEnabled = () => {
            return InvoiceWorkflow.configuration && InvoiceWorkflow.configuration.additionalInfo && InvoiceWorkflow.configuration.additionalInfo.enabled === true
        }
        this.remove = item => {
            let content = item.number ? item.number : "#" + item.id
            return modals.confirmDelete(content, () => Invoice.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast(InvoiceConst.eventUpdate)))
        }
        this.removeMany = items => {
            const ids = (items || []).map(item => item && item.id).filter(id => id != null).filter((id, index, values) => values.indexOf(id) === index)
            if (!ids.length) {
                return
            }
            return modals.confirmDelete(`zaznaczone dokumenty (${ids.length})`, () => Invoice.deleteBatch({ids: ids}).$promise.then(() => $rootScope.$broadcast(InvoiceConst.eventUpdate)))
        }
        this.deleteTouch = (invoiceId, userId) => {
            return modals.confirmDelete("wybrany rekord", () => Invoice.deleteTouch({id: invoiceId, userId: userId}).$promise.then(() => $rootScope.$broadcast(InvoiceConst.eventUpdate)));
        }
        this.isDelayed = (time, paidAmountLeftGross) => {
            return moment(this.currentTime).isAfter(moment(time).endOf('day')) && paidAmountLeftGross > 0
        }
        this.isPricingDiffFromCosts = item => {
            if (item == null || item.pricing == null || item.costsAmount == null) {
                return false
            }
            return item.costsAmount.totalNet !== item.pricing.totalNet ||
                item.costsAmount.totalVat !== item.pricing.totalVat ||
                item.costsAmount.totalGross !== item.pricing.totalGross
        }
        this.isSettlementsAmountLeft = item => {
            if (item == null || item.settlementsAmountLeft == null) {
                return false
            }
            return item.settlementsAmountLeft.totalNet !== 0 ||
                item.settlementsAmountLeft.totalVat !== 0 ||
                item.settlementsAmountLeft.totalGross !== 0
        }
        this.isSettlementsAmountOverpaid = item => {
            if (item == null || item.settlementsAmountLeft == null) {
                return false
            }
            return item.settlementsAmountLeft.totalGross < 0 ||
                item.settlementsAmountLeft.totalNet < 0 ||
                item.settlementsAmountLeft.totalVat < 0
        }
        this.isUserAccountantOrManager = () => {
            return Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_ACCOUNTING', 'ROLE_INVOICE_DOCUMENTS_ALL'])
        }
        this.isDocumentTerminal = item => {
            return InvoiceWorkflow.isTerminal(item.status)
        }
        this.toggleFlag = (item, flag) => {
            const previousFlagMetadata = item ? angular.copy(item.flagMetadata) : null
            if (!item || !item.id) {
                return
            }

            return Invoice.toggleFlag({id: item.id}, {flag: flag}).$promise.then(() => {
                return Invoice.get({id: item.id}).$promise
            }).then(fresh => {
                item.flagMetadata = (fresh && fresh.flagMetadata && fresh.flagMetadata.flag != null) ? fresh.flagMetadata : null
                toastr.success("Zapisano")
                $rootScope.$broadcast(InvoiceConst.eventUpdate)
                return item.flagMetadata
            }).catch(() => {
                item.flagMetadata = previousFlagMetadata
                toastr.error("Nie udało się zapisać flagi")
            })
        }
        this.resetKsefXmlExport = (ids) => {
            let idsToReset = Array.isArray(ids) ? ids : [ids]
            idsToReset = idsToReset.filter(id => id != null)
            if (idsToReset.length === 0) {
                return
            }
            return modals.confirm("Czy na pewno zresetować informacje o eksporcie XML KSeF?", () =>
                Invoice.resetKsefXmlExport({ids: idsToReset}).$promise.then(() => {
                    $rootScope.$broadcast(InvoiceConst.eventUpdate)
                })
            )
        }
        this.importBgt = () => InvoiceBgtImportService.open()
    })
    .run(function (NavbarLeftMenu, Principal, $http, $interval, $rootScope, InvoiceWorkflow) {
        const menuPath = '/invoice'

        function loadCounter() {
            Principal.identity().then(account => {
                let auth = Principal.hasAnyAuthority(['ROLE_INVOICE_DOCUMENTS_MODULE'])
                if (!auth) {
                    NavbarLeftMenu.updateCount(menuPath, 0)
                    return;
                }

                InvoiceWorkflow.load().catch(angular.noop)

                $http.get("/crm/api/invoice/table?filter=assigned").then(response => {
                    let statistics = response.data
                    NavbarLeftMenu.updateCount(menuPath, statistics.fullListSize)
                }).catch(() => {
                    NavbarLeftMenu.updateCount(menuPath, 0)
                })
            })
        }

        NavbarLeftMenu.add({
            authorities: "ROLE_INVOICE_DOCUMENTS_MODULE",
            path: menuPath,
            ico: "fa fa-fw fa-usd",
            name: 'invoice.menu',
            order: 83
        })

        $rootScope.$on("invoice.updated", () => loadCounter())
        $rootScope.$on("authenticationChanged", () => loadCounter())

        let intPromise = null;

        function initAutoRefresh() {
            $interval.cancel(intPromise)
            loadCounter()
            intPromise = $interval(initAutoRefresh, 60000)
        }

        this.$onDestroy = () => $interval.cancel(intPromise);

        initAutoRefresh()
    })
    .config(function ($stateProvider) {
        $stateProvider.state('invoiceList', {
            parent: 'app',
            url: '/invoice?{page:int}&{size:int}&sort&search&periodStart&periodEnd&saleStart&saleEnd&additionalInfoStart&additionalInfoEnd&status&type&currency&worker&workerMissing&toucher&seller&buyer&paymentMethod&filter&customFilter&agreementFilter&assignmentFilter&costProject&bgtProject&bgtGroup&bgtGroups&bgtMissing&flags',
            data: {
                authorities: ['ROLE_INVOICE_DOCUMENTS_MODULE']
            },
            params: {
                type: {array: true, value: [], squash: false},
                status: {array: true, value: [], squash: false},
                bgtGroups: {array: true, value: [], squash: false},
                filter: {value: 'assigned'},
                flags: {array: true, value: [], squash: false, type: "int"},
            },
            views: {
                'content@': 'invoiceList'
            },
            resolve: {
                statistics: (Invoice, $stateParams) => Invoice.tableStatistics(angular.copy($stateParams)).$promise,
                filters: $stateParams => angular.copy($stateParams),
                page: (Invoice, $stateParams) => Invoice.table(angular.copy($stateParams)).$promise
            }
        })
        $stateProvider.state('invoiceShortAcceptanceGuide', {
            parent: 'app',
            url: '/invoice/guide/short-acceptance',
            data: {
                authorities: ['ROLE_INVOICE_DOCUMENTS_MODULE']
            },
            views: {
                'content@': {
                    templateUrl: 'app/invoice/short-acceptance-guide.html',
                    controller: 'InvoiceShortAcceptanceGuideController',
                    controllerAs: '$ctrl'
                }
            }
        })
        $stateProvider.state('invoiceRegistration', {
            parent: 'app',
            url: '/invoice/{id}/edit',
            data: {
                authorities: ['ROLE_INVOICE_DOCUMENTS_MODULE']
            },
            views: {
                'content@': {
                    templateUrl: 'app/invoice/edit.html',
                    controller: 'InvoiceRegistrationController',
                    controllerAs: '$ctrl'
                }
            },
            resolve: {
                item: (Invoice, $stateParams) => Invoice.get({id: $stateParams.id}).$promise
            }
        })
        $stateProvider.state('invoiceShowFull', {
            parent: 'app',
            url: '/invoice/{id}',
            data: {
                authorities: ['ROLE_INVOICE_DOCUMENTS_MODULE']
            },
            views: {
                'content@': {
                    templateUrl: 'app/invoice/show.html',
                    controller: 'InvoiceShowFullController',
                    controllerAs: '$ctrl'
                }
            },
        })
    })
